import { createElement, Component, PropTypes } from 'rlink-react';
import GreenhouseJob from 'rlink-greenhouse/GreenhouseJob';
import groupJobsByDepartment from 'rlink-greenhouse/groupJobsByDepartment';
import spliceJobPostings from 'rlink-greenhouse/spliceJobPostings';
import NavLink from 'rlink-router/NavLink';
import themeable from 'rlink-theme/themeable';

import CategorizedJobs from 'components/Careers/CategorizedJobs';
import careersScene from 'helpers/scenes/careersScene';
import getArticleLoader from 'helpers/getArticleLoader';

const DEPARTMENTS_PER_ROW = 3;

export default class CareersPanel extends Component {
  hasJobPostings () {
    return this.props.jobPostings && this.props.jobPostings.length > 0;
  }

  initCareerScene () {
    if (this.hasJobPostings()) {
      careersScene();
    }
  }

  componentDidUpdate () {
    this.initCareerScene();
  }

  componentDidMount () {
    this.initCareerScene();
  }

  render () {
    const { theme, jobPostings } = this.props;
    const groupedJobPostings = spliceJobPostings(
      groupJobsByDepartment(jobPostings),
      DEPARTMENTS_PER_ROW
    );
    return (
      <section className="node node-single-page-section node-promoted view-mode-full">
        <article id="careers" className="layout-text bg-white clearfix">
          <div className="wrapper">
            <div className="row">
              <h2>Careers</h2>
              <div>
                <p>Want to create ridiculously fun games? We do, too!</p>
                <p>To do this, we focus on the belief that anything is possible when you put a team of smart and passionate
                people into a room. Our culture has always emphasized ownership, creative freedom and teamwork. That’s
                because the best games ever created were always the result of a group of dedicated people who didn’t
                shy away from doing things that have never been done before. On top of that, we know that the next
                big game idea can come from anyone in the room – whether you’re a student, seasoned professional or
                10-year industry veteran.</p>
                <p>As a studio, our role is to create a workplace where people are energized and empowered to not only do
                their best work but to continually surpass their best. We’ll push you out of your comfort zone to become
                the best version of you by giving you the ownership and creative freedom to solve our most challenging
                problems.</p>
                <p>If you want to bring your career to the next level, Relic might be the place for you. Check out our job
                openings below.</p>
                <p>
                  Please click this link to view our
                  {' '}
                  <NavLink
                    className={theme.CandidateNoticeLink}
                    href={{
                      view: 'home',
                      params: {slug: 'candidate-notice'},
                    }}
                    onClick={() => {
                      getArticleLoader().show(() => {
                        $('.ajax-node').hide();
                      });
                    }}>
                    Candidate Application Notice.
                  </NavLink>
                </p>
              </div>
            </div>
          </div>
        </article>
        <article id="current-vacancies" className="layout-standard text-white clearfix">
          <div className="wrapper">
            <div className="row">
              <h2>Current Vacancies</h2>
              <div className="view view-job-positions view-id-job_positions view-display-id-job_directory view-dom-id-9a8d3df4af0440d1debae513c70fd82e">
                <div className="view-content">
                  {groupedJobPostings.map(jobRow => (
                    <div key={JSON.stringify(jobRow)} className="row">
                      {Object.entries(jobRow).map(([department, jobs]) => (
                        <CategorizedJobs
                          key={department}
                          category={department}
                          jobs={jobs} />
                      ))}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </article>
      </section>
    );
  }
}

CareersPanel.propTypes = {
  jobPostings: PropTypes.arrayOf(PropTypes.instanceOf(GreenhouseJob)),
};

themeable(CareersPanel, {
  classes: [
    'CandidateNoticeLink',
  ],
});



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/components/Careers/CareersPanel.jsx